import React from 'react';
import Counter from '../ReusableComponents/counter';

//MUI
import { styled } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';
import { Container } from '@mui/system';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Button from '@mui/material/Button';
import WestIcon from '@mui/icons-material/West';
import EastIcon from '@mui/icons-material/East';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';

//Images
import im5 from '../../assets/images/SDG/5.jpg';
import im8 from '../../assets/images/SDG/8.jpg';
import im16 from '../../assets/images/SDG/16.jpg';
import bg from '../../assets/images/background.svg';
import P5 from '../../assets/images/cardImages/human_rights.jpg';
import P5_small from '../../assets/images/cardImages/mobile/human_rights.jpg';
import GavelRoundedIcon from '@mui/icons-material/GavelRounded';
import CurrencyRupeeRoundedIcon from '@mui/icons-material/CurrencyRupeeRounded';
import AssessmentOutlinedIcon from '@mui/icons-material/AssessmentOutlined';


//chart js
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, ArcElement, } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';



const counterData = [
    {
        "num": 100,
        "label": "Plants and Offices assessed on Human Rights issues ",
        "icon": GavelRoundedIcon,
        "prefix": "",
        "isdecimal": false,
        "suffix": "%"
    },
    {
        "num": 100,
        "label": "Workforce covered under Minimum wages Act are paid More than Minimum Wage",
        "icon": GavelRoundedIcon,
        "prefix": "",
        "isdecimal": false,
        "suffix": "%"
    },
    {
        "num": 8.05,
        "label": "Gross wages paid to females",
        "icon": CurrencyRupeeRoundedIcon,
        "prefix": "",
        "isdecimal": true,
        "suffix": "%"
    }
]


const ExpandMore = styled((props) => {
    const { expand, ...other } = props;
    return <IconButton {...other} />;
})(({ theme, expand }) => ({
    transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shortest,
    }),
}));

const StyledBox = styled(Box)`
  ${({ theme }) => `
  cursor: pointer;
  transition: ${theme.transitions.create(['transform'], {
    duration: theme.transitions.duration.standard,
})};
  &:hover {
    transform: scale(2);
  }
  `}
`;

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
    ChartDataLabels
);

ChartJS.register(ArcElement, Tooltip, Legend);

//------------------------------------------------

export const options1 = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
        title: {
            display: false,
            text: 'Training',
        },
        legend: {
            position: 'top',
            labels: {
                font: {
                    family: 'Georama'
                }
            }
        },
        datalabels: {
            anchor: 'center',
            align: 'bottom',
            formatter: (value, context) => {
                let keys = Object.keys(context.dataset.data)
                let key = keys[context.dataIndex]
                if (context.dataset.data[key] !== 0) {
                    return context.dataset.data[key].toLocaleString('en-In');
                }

            },
            padding: -10,
            color: "white",
            font: {
                family: 'Georama',
                size: 14,
                weight: 'bold',

            }
        }
    },
    scales: {
        x: {
            stacked: true,
            grid: {
                display: false
            },
            ticks: {
                font: {
                    family: 'Georama'
                }
            }
        },
        y: {
            display: true,
            stacked: true,
            grid: {
                display: true,
            },
            ticks: {
                font: {
                    family: 'Georama'
                }
            }
        },
    },
};

const labels1 = ['Board of Directors (BoD)', 'Employees', 'Workers'];

export const data1 = {
    labels1,
    datasets: [
        {
            label: 'Male',
            data: {
                "Board of Directors (BoD)": 0.66,
                "Employees": 0.11,
                "Workers": 0.07
            },
            backgroundColor: '#e31837',
            barThickness: 40
        },
        {
            label: 'Female',
            data: {
                "Board of Directors (BoD)": 0.54,
                "Employees": 0.13,
                "Workers": 0.04
            },
            backgroundColor: '#4d4d4f',
            barThickness: 40
        }
    ],
};

//-----------------------------------------------------------

export const options2 = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
        title: {
            display: false,
            text: 'Training',
        },
        legend: {
            position: 'top',
            labels: {
                font: {
                    family: 'Georama'
                }
            }
        },
        datalabels: {
            anchor: 'center',
            align: 'bottom',
            formatter: (value, context) => {
                let keys = Object.keys(context.dataset.data)
                let key = keys[context.dataIndex]
                if (context.dataset.data[key] !== 0) {
                    return context.dataset.data[key].toLocaleString('en-In') + "%";
                }

            },
            padding: -10,
            color: "white",
            font: {
                family: 'Georama',
                size: 14,
                weight: 'bold',

            }
        }
    },
    scales: {
        x: {
            grid: {
                display: false
            },
            ticks: {
                font: {
                    family: 'Georama'
                }
            }
        },
        y: {
            display: true,

            grid: {
                display: true,
            },
            ticks: {
                font: {
                    family: 'Georama'
                }
            }
        },
    },
};

const labels2 = ['Gross Wages Paid to Female Workforce'];

export const data2 = {
    labels2,
    datasets: [
        {
            label: 'FY23',
            data: {
                "Gross Wages Paid to Female Workforce": 5.63,
            },
            backgroundColor: '#747474',
            barThickness: 60
        },
        {
            label: 'FY24',
            data: {
                "Gross Wages Paid to Female Workforce": 6.55,
            },
            backgroundColor: '#4d4d4f',
            barThickness: 60
        },
        {
            label: 'FY25',
            data: {
                "Gross Wages Paid to Female Workforce": 8.05,
            },
            backgroundColor: '#e31837',
            barThickness: 60
        }
    ],
};

const Sectionc5 = () => {
    const [expanded1, setExpanded1] = React.useState(false);
    const handleExpandClick1 = () => {
        setExpanded1(!expanded1);
    };

    const [expanded2, setExpanded2] = React.useState(false);
    const handleExpandClick2 = () => {
        setExpanded2(!expanded2);
    };

    const [expanded3, setExpanded3] = React.useState(false);
    const handleExpandClick3 = () => {
        setExpanded3(!expanded3);
    };

    const [expanded3g, setExpanded3g] = React.useState(false);
    const handleExpandClick3g = () => {
        setExpanded3g(!expanded3g);
    };

    const [expanded4, setExpanded4] = React.useState(false);
    const handleExpandClick4 = () => {
        setExpanded4(!expanded4);
    };

    const [expanded5, setExpanded5] = React.useState(false);
    const handleExpandClick5 = () => {
        setExpanded5(!expanded5);
    };

    const [expanded6, setExpanded6] = React.useState(false);
    const handleExpandClick6 = () => {
        setExpanded6(!expanded6);
    };

    const [expanded7, setExpanded7] = React.useState(false);
    const handleExpandClick7 = () => {
        setExpanded7(!expanded7);
    };

    const [expanded8, setExpanded8] = React.useState(false);
    const handleExpandClick8 = () => {
        setExpanded8(!expanded8);
    };

    const [expanded8s, setExpanded8s] = React.useState(false);
    const handleExpandClick8s = () => {
        setExpanded8s(!expanded8s);
    };

    const [expanded9, setExpanded9] = React.useState(false);
    const handleExpandClick9 = () => {
        setExpanded9(!expanded9);
    };

    const [expanded10, setExpanded10] = React.useState(false);
    const handleExpandClick10 = () => {
        setExpanded10(!expanded10);
    };

    const [expanded11, setExpanded11] = React.useState(false);
    const handleExpandClick11 = () => {
        setExpanded11(!expanded11);
    };

    const [expanded12, setExpanded12] = React.useState(false);
    const handleExpandClick12 = () => {
        setExpanded12(!expanded12);
    };

    const [expanded13, setExpanded13] = React.useState(false);
    const handleExpandClick13 = () => {
        setExpanded13(!expanded13);
    };

    const [expanded14, setExpanded14] = React.useState(false);
    const handleExpandClick14 = () => {
        setExpanded14(!expanded14);
    };

    const [expanded15, setExpanded15] = React.useState(false);
    const handleExpandClick15 = () => {
        setExpanded15(!expanded15);
    };

    const [expand, setExpand] = React.useState(false);
    const expandAll = () => {
        setExpand(true); setExpanded1(true); setExpanded2(true); setExpanded3(true); setExpanded3g(true); setExpanded4(true); setExpanded5(true); setExpanded6(true); setExpanded7(true); setExpanded8(true); setExpanded8s(true); setExpanded9(true); setExpanded10(true); setExpanded11(true); setExpanded12(true); setExpanded13(true); setExpanded14(true); setExpanded15(true);
    };
    const closeAll = () => {
        setExpand(false); setExpanded1(false); setExpanded2(false); setExpanded3(false); setExpanded3g(false); setExpanded4(false); setExpanded5(false); setExpanded6(false); setExpanded7(false); setExpanded8(false); setExpanded8s(false); setExpanded9(false); setExpanded10(false); setExpanded11(false); setExpanded12(false); setExpanded13(false); setExpanded14(false); setExpanded15(false);
    };


    return (
        <Container>
            <Box mt={3} sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <Button startIcon={<WestIcon />} sx={{ fontWeight: 'bold' }} href='/sectionc4'>
                    Previous
                </Button>
                <Button endIcon={<EastIcon />} sx={{ fontWeight: 'bold' }} href='/sectionc6'>
                    Next
                </Button>
            </Box>
            <Box mt={3} sx={{
                display: 'flex',
                alignItems: 'center',
                height: { xs: '150px', md: '300px' },
                backgroundImage: `url(${bg})`,
                backgroundSize: 'cover',
                borderRadius: '8px'
            }}>
                <Box px={5} py={3} sx={{ width: '100%' }}>
                    <Typography sx={{ typography: { xs: 'h5', md: 'h4' }, color: "#ffffff" }}>
                        Principle 5
                    </Typography>
                    <Typography mt={2} sx={{ typography: { xs: 'body1', md: 'h6' }, color: "#ffffff" }}>
                        Human Rights
                    </Typography>
                    <Box mt={2} sx={{ display: { xs: 'none', lg: 'flex' } }}>
                        <Typography variant='body1' sx={{ color: "#ffffff" }}>
                            Businesses should respect and promote human rights
                        </Typography>
                    </Box>

                    <Box mt={3} sx={{ display: { xs: 'none', lg: 'flex' } }}>
                        <StyledBox><img src={im5} height="40" alt="svg" /></StyledBox>
                        <StyledBox><img src={im8} height="40" alt="svg" /></StyledBox>
                        <StyledBox><img src={im16} height="40" alt="svg" /></StyledBox>
                    </Box>
                </Box>
                <Box sx={{
                    backgroundImage: { xs: `url(${P5_small})`, sm: `url(${P5})` },
                    backgroundSize: 'cover',
                    borderRadius: '0 8px 8px 0',
                    height: { xs: '150px', md: '300px' },
                    width: '100%'
                }}>
                </Box>
            </Box>
            <Box px={4} py={6} mt={{ xs: 4, md: 8 }} sx={{ backgroundColor: '#e6e7e8', borderRadius: '8px' }}>
                <Box mb={6} display="flex" justifyContent="center">
                    <Typography className='heading' variant='h4' sx={{ color: "#e31837", fontSize: "34px", fontWeight: "900" }}>
                        Highlights
                    </Typography>
                </Box>
                <Box>
                    <Counter data={counterData} />
                </Box>
            </Box>
            <Box mt={5} sx={{ textAlign: "right" }}>
                <button onClick={!expand ? expandAll : closeAll} className="custom-button">
                    <span>
                        {!expand ? 'Expand All' : "Close All"}
                        {!expand ? <ArrowDropDownIcon /> : <ArrowDropUpIcon />}
                    </span>
                </button>
            </Box>
            <Box mt={4}>
                <Typography className='heading' variant='h4' sx={{ fontSize: '28px', color: "#e31837" }}>
                    Essential Indicators
                </Typography>
            </Box>
            <Box mt={2} sx={{ borderBottom: 1, borderColor: "#d3d3c8" }}>
                <Box mb={2}>
                    <Box>
                        <Typography variant='body1' sx={{ fontWeight: 'bold', color: "#e31837" }}>
                            1. Employees and workers who have been provided training on human rights issues and policy(ies) of the entity, in the following format:
                            <ExpandMore
                                expand={expanded1}
                                onClick={handleExpandClick1}
                                aria-expanded={expanded1}
                                aria-label="show more"
                            >
                                <ExpandMoreIcon />
                            </ExpandMore>
                        </Typography>
                    </Box>
                </Box>
                <Collapse in={expanded1} timeout="auto" unmountOnExit>
                    <Box mb={5}>
                        <TableContainer component={Paper}>
                            <Table sx={{ minWidth: 650 }} size="small" >
                                <TableHead sx={{ "& th": { color: '#FFFFFF' } }}>
                                    <TableRow sx={{ backgroundColor: "#4d4d4f" }}>
                                        <TableCell rowSpan={2}><strong>Category</strong></TableCell>
                                        <TableCell align="center" colSpan={3}><strong>FY 2025-26</strong></TableCell>
                                        <TableCell align="center" colSpan={3}><strong>FY 2024-25</strong></TableCell>
                                    </TableRow>
                                    <TableRow sx={{ backgroundColor: "#4d4d4f" }}>
                                        <TableCell align="center"><strong>Total (A)</strong></TableCell>
                                        <TableCell align="center"><strong>No. of employees/ workers covered (B)</strong></TableCell>
                                        <TableCell align="center"><strong>%(B/A)</strong></TableCell>
                                        <TableCell align="center"><strong>Total (C)</strong></TableCell>
                                        <TableCell align="center"><strong>No. of employees/ workers covered (D) </strong></TableCell>
                                        <TableCell align="center"><strong>%(D/C)
                                        </strong></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody sx={{ "& tr": { borderBottom: "1px solid #C3C4BD" } }}>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row" align='center' colSpan={7} sx={{ backgroundColor: "#e6e7e8" }} >
                                            <strong>Employees</strong>
                                        </TableCell>
                                    </TableRow>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row">
                                            <strong>Permanent</strong>
                                        </TableCell>
                                        <TableCell align='center'>16,642</TableCell>
                                        <TableCell align='center'>16,475</TableCell>
                                        <TableCell align='center'>99.00</TableCell>
                                        <TableCell align='center'>14,755</TableCell>
                                        <TableCell align='center'>14,066</TableCell>
                                        <TableCell align='center'>95.33</TableCell>
                                    </TableRow>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row">
                                            <strong>Other than permanent</strong>
                                        </TableCell>
                                        <TableCell align='center'>441</TableCell>
                                        <TableCell align='center'>437</TableCell>
                                        <TableCell align='center'>99.09</TableCell>
                                        <TableCell align='center'>464</TableCell>
                                        <TableCell align='center'>417</TableCell>
                                        <TableCell align='center'>89.89</TableCell>
                                    </TableRow>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row">
                                            <strong>Total Employees</strong>
                                        </TableCell>
                                        <TableCell align='center'><strong>17,083</strong></TableCell>
                                        <TableCell align='center'><strong>16,912</strong></TableCell>
                                        <TableCell align='center'><strong>99.00</strong></TableCell>
                                        <TableCell align='center'><strong>15,219</strong></TableCell>
                                        <TableCell align='center'><strong>14,483</strong></TableCell>
                                        <TableCell align='center'><strong>95.16</strong></TableCell>
                                    </TableRow>

                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row" align='center' colSpan={7} sx={{ backgroundColor: "#e6e7e8" }} >
                                            <strong>Workers</strong>
                                        </TableCell>
                                    </TableRow>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row">
                                            <strong>Permanent</strong>
                                        </TableCell>
                                        <TableCell align='center'>10,123</TableCell>
                                        <TableCell align='center'>9,817</TableCell>
                                        <TableCell align='center'>96.98</TableCell>
                                        <TableCell align='center'>10,467</TableCell>
                                        <TableCell align='center'>7,549</TableCell>
                                        <TableCell align='center'>72.12</TableCell>
                                    </TableRow>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row">
                                            <strong>Other than permanent</strong>
                                        </TableCell>
                                        <TableCell align='center'>64,687</TableCell>
                                        <TableCell align='center'>42,151</TableCell>
                                        <TableCell align='center'>65.16</TableCell>
                                        <TableCell align='center'>53,070</TableCell>
                                        <TableCell align='center'>44,340</TableCell>
                                        <TableCell align='center'>83.55</TableCell>
                                    </TableRow>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row">
                                            <strong>Total Workers</strong>
                                        </TableCell>
                                        <TableCell align='center'><strong>74,810</strong></TableCell>
                                        <TableCell align='center'><strong>51,968</strong></TableCell>
                                        <TableCell align='center'><strong>69.47</strong></TableCell>
                                        <TableCell align='center'><strong>63,537</strong></TableCell>
                                        <TableCell align='center'><strong>51,889</strong></TableCell>
                                        <TableCell align='center'><strong>81.67</strong></TableCell>
                                    </TableRow>
                                </TableBody>

                            </Table>
                        </TableContainer>
                    </Box>
                </Collapse>
            </Box>
            <Box mt={2} sx={{ borderBottom: 1, borderColor: "#d3d3c8" }}>
                <Box mb={2}>
                    <Typography variant='body1' sx={{ fontWeight: 'bold', color: "#e31837" }}>
                        2. Details of minimum wages paid to employees and workers, in the following format:
                        <ExpandMore
                            expand={expanded2}
                            onClick={handleExpandClick2}
                            aria-expanded={expanded2}
                            aria-label="show more"
                        >
                            <ExpandMoreIcon />
                        </ExpandMore>
                    </Typography>
                </Box>
                <Collapse in={expanded2} timeout="auto" unmountOnExit>
                    <Box mb={5}>
                        <TableContainer component={Paper}>
                            <Table sx={{ minWidth: 650 }} size="small" >
                                <TableHead sx={{ "& th": { color: '#FFFFFF' } }}>
                                    <TableRow sx={{ backgroundColor: "#4d4d4f" }}>
                                        <TableCell align="center" rowSpan={3}><strong>Category</strong></TableCell>
                                        <TableCell align="center" colSpan={5}><strong>FY 2025-26</strong></TableCell>
                                        <TableCell align="center" colSpan={5}><strong>FY 2024-25</strong></TableCell>
                                    </TableRow>
                                    <TableRow sx={{ backgroundColor: "#4d4d4f" }}>
                                        <TableCell align="center" rowSpan={2}><strong>Total (A)</strong></TableCell>
                                        <TableCell align="center" colSpan={2}><strong>Equal to Minimum Wage </strong></TableCell>
                                        <TableCell align="center" colSpan={2}><strong>More than Minimum Wage</strong></TableCell>
                                        <TableCell align="center" rowSpan={2}><strong>Total (D)</strong></TableCell>
                                        <TableCell align="center" colSpan={2}><strong>Equal to Minimum Wage</strong></TableCell>
                                        <TableCell align="center" colSpan={2}><strong>More than Minimum Wage</strong></TableCell>
                                    </TableRow>
                                    <TableRow sx={{ backgroundColor: "#4d4d4f" }}>
                                        <TableCell align="center"><strong>No. (B) </strong></TableCell>
                                        <TableCell align="center"><strong>% (B / A)</strong></TableCell>
                                        <TableCell align="center"><strong>No. (C) </strong></TableCell>
                                        <TableCell align="center"><strong>% (C / A)</strong></TableCell>
                                        <TableCell align="center"><strong>No. (E) </strong></TableCell>
                                        <TableCell align="center"><strong>% (E / D)</strong></TableCell>
                                        <TableCell align="center"><strong>No. (F) </strong></TableCell>
                                        <TableCell align="center"><strong>% (F / D)</strong></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody sx={{ "& tr": { borderBottom: "1px solid #C3C4BD" } }}>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row" align='center' colSpan={11} sx={{ backgroundColor: "#e6e7e8" }} >
                                            <strong>Employees</strong>
                                        </TableCell>
                                    </TableRow>

                                    <TableRow>
                                        <TableCell component="th" scope="row">Permanent</TableCell>
                                        <TableCell align='center'>16,642</TableCell>
                                        <TableCell align='center'>0</TableCell>
                                        <TableCell align='center'>0</TableCell>
                                        <TableCell align='center'>16,642</TableCell>
                                        <TableCell align='center'>100</TableCell>
                                        <TableCell align='center'>14,755</TableCell>
                                        <TableCell align='center'>0</TableCell>
                                        <TableCell align='center'>0.00</TableCell>
                                        <TableCell align='center'>14,755</TableCell>
                                        <TableCell align='center'>100</TableCell>
                                    </TableRow>

                                    <TableRow>
                                        <TableCell component="th" scope="row">Male</TableCell>
                                        <TableCell align='center'>14,476</TableCell>
                                        <TableCell align='center'>0</TableCell>
                                        <TableCell align='center'>0</TableCell>
                                        <TableCell align='center'>14,476</TableCell>
                                        <TableCell align='center'>100</TableCell>
                                        <TableCell align='center'>13,181</TableCell>
                                        <TableCell align='center'>0</TableCell>
                                        <TableCell align='center'>0.00</TableCell>
                                        <TableCell align='center'>13,181</TableCell>
                                        <TableCell align='center'>100</TableCell>
                                    </TableRow>

                                    <TableRow>
                                        <TableCell component="th" scope="row">Female</TableCell>
                                        <TableCell align='center'>2,166</TableCell>
                                        <TableCell align='center'>0</TableCell>
                                        <TableCell align='center'>0</TableCell>
                                        <TableCell align='center'>2,166</TableCell>
                                        <TableCell align='center'>100</TableCell>
                                        <TableCell align='center'>1,574</TableCell>
                                        <TableCell align='center'>0</TableCell>
                                        <TableCell align='center'>0.00</TableCell>
                                        <TableCell align='center'>1,574</TableCell>
                                        <TableCell align='center'>100</TableCell>
                                    </TableRow>

                                    <TableRow>
                                        <TableCell component="th" scope="row">Other than permanent</TableCell>
                                        <TableCell align='center'>441</TableCell>
                                        <TableCell align='center'>0</TableCell>
                                        <TableCell align='center'>0</TableCell>
                                        <TableCell align='center'>441</TableCell>
                                        <TableCell align='center'>100</TableCell>
                                        <TableCell align='center'>464</TableCell>
                                        <TableCell align='center'>0</TableCell>
                                        <TableCell align='center'>0.00</TableCell>
                                        <TableCell align='center'>464</TableCell>
                                        <TableCell align='center'>100</TableCell>
                                    </TableRow>

                                    <TableRow>
                                        <TableCell component="th" scope="row">Male</TableCell>
                                        <TableCell align='center'>266</TableCell>
                                        <TableCell align='center'>0</TableCell>
                                        <TableCell align='center'>0</TableCell>
                                        <TableCell align='center'>266</TableCell>
                                        <TableCell align='center'>100</TableCell>
                                        <TableCell align='center'>291</TableCell>
                                        <TableCell align='center'>0</TableCell>
                                        <TableCell align='center'>0.00</TableCell>
                                        <TableCell align='center'>291</TableCell>
                                        <TableCell align='center'>100</TableCell>
                                    </TableRow>

                                    <TableRow>
                                        <TableCell component="th" scope="row">Female</TableCell>
                                        <TableCell align='center'>175</TableCell>
                                        <TableCell align='center'>0</TableCell>
                                        <TableCell align='center'>0</TableCell>
                                        <TableCell align='center'>175</TableCell>
                                        <TableCell align='center'>100</TableCell>
                                        <TableCell align='center'>173</TableCell>
                                        <TableCell align='center'>0</TableCell>
                                        <TableCell align='center'>0.00</TableCell>
                                        <TableCell align='center'>173</TableCell>
                                        <TableCell align='center'>100</TableCell>
                                    </TableRow>

                                    <TableRow>
                                        <TableCell component="th" scope="row" align='center' colSpan={11} sx={{ backgroundColor: "#e6e7e8" }}>
                                            <strong>Workers</strong>
                                        </TableCell>
                                    </TableRow>

                                    {/* Workers - Permanent */}
                                    <TableRow>
                                        <TableCell component="th" scope="row">Permanent</TableCell>
                                        <TableCell align='center'>10,123</TableCell>
                                        <TableCell align='center'>0</TableCell>
                                        <TableCell align='center'>0</TableCell>
                                        <TableCell align='center'>10,123</TableCell>
                                        <TableCell align='center'>100</TableCell>
                                        <TableCell align='center'>10,467</TableCell>
                                        <TableCell align='center'>0</TableCell>
                                        <TableCell align='center'>0.00</TableCell>
                                        <TableCell align='center'>10,467</TableCell>
                                        <TableCell align='center'>100</TableCell>
                                    </TableRow>

                                    <TableRow>
                                        <TableCell component="th" scope="row">Male</TableCell>
                                        <TableCell align='center'>10,060</TableCell>
                                        <TableCell align='center'>0</TableCell>
                                        <TableCell align='center'>0</TableCell>
                                        <TableCell align='center'>10,060</TableCell>
                                        <TableCell align='center'>100</TableCell>
                                        <TableCell align='center'>10,409</TableCell>
                                        <TableCell align='center'>0</TableCell>
                                        <TableCell align='center'>0.00</TableCell>
                                        <TableCell align='center'>10,409</TableCell>
                                        <TableCell align='center'>100</TableCell>
                                    </TableRow>

                                    <TableRow>
                                        <TableCell component="th" scope="row">Female</TableCell>
                                        <TableCell align='center'>63</TableCell>
                                        <TableCell align='center'>0</TableCell>
                                        <TableCell align='center'>0</TableCell>
                                        <TableCell align='center'>63</TableCell>
                                        <TableCell align='center'>100</TableCell>
                                        <TableCell align='center'>58</TableCell>
                                        <TableCell align='center'>0</TableCell>
                                        <TableCell align='center'>0.00</TableCell>
                                        <TableCell align='center'>58</TableCell>
                                        <TableCell align='center'>100</TableCell>
                                    </TableRow>

                                    {/* Workers - Other than Permanent */}
                                    <TableRow>
                                        <TableCell component="th" scope="row">Other than permanent</TableCell>
                                        <TableCell align='center'>64,687</TableCell>
                                        <TableCell align='center'>0</TableCell>
                                        <TableCell align='center'>0</TableCell>
                                        <TableCell align='center'>64,687</TableCell>
                                        <TableCell align='center'>100</TableCell>
                                        <TableCell align='center'>22,840</TableCell>
                                        <TableCell align='center'>0</TableCell>
                                        <TableCell align='center'>0.00</TableCell>
                                        <TableCell align='center'>22,840</TableCell>
                                        <TableCell align='center'>100</TableCell>
                                    </TableRow>

                                    <TableRow>
                                        <TableCell component="th" scope="row">Male</TableCell>
                                        <TableCell align='center'>56,502</TableCell>
                                        <TableCell align='center'>0</TableCell>
                                        <TableCell align='center'>0</TableCell>
                                        <TableCell align='center'>56,502</TableCell>
                                        <TableCell align='center'>100</TableCell>
                                        <TableCell align='center'>21,604</TableCell>
                                        <TableCell align='center'>0</TableCell>
                                        <TableCell align='center'>0.00</TableCell>
                                        <TableCell align='center'>21,604</TableCell>
                                        <TableCell align='center'>100</TableCell>
                                    </TableRow>

                                    <TableRow>
                                        <TableCell component="th" scope="row">Female</TableCell>
                                        <TableCell align='center'>8,185</TableCell>
                                        <TableCell align='center'>0</TableCell>
                                        <TableCell align='center'>0</TableCell>
                                        <TableCell align='center'>8,185</TableCell>
                                        <TableCell align='center'>100</TableCell>
                                        <TableCell align='center'>1,236</TableCell>
                                        <TableCell align='center'>0</TableCell>
                                        <TableCell align='center'>0.00</TableCell>
                                        <TableCell align='center'>1,236</TableCell>
                                        <TableCell align='center'>100</TableCell>
                                    </TableRow>
                                </TableBody>

                            </Table>
                        </TableContainer>
                    </Box>
                </Collapse>
            </Box>
            <Box mt={2} sx={{ borderBottom: 1, borderColor: "#d3d3c8" }}>
                <Box mb={2}>
                    <Typography variant='body1' sx={{ fontWeight: 'bold', color: "#e31837" }}>
                        3. Details of remuneration/ salary/ wages, in the following format:
                        <ExpandMore
                            expand={expanded3}
                            onClick={handleExpandClick3}
                            aria-expanded={expanded3}
                            aria-label="show more"
                        >
                            <ExpandMoreIcon />
                        </ExpandMore>
                        <ExpandMore
                            expand={expanded3g}
                            onClick={handleExpandClick3g}
                            aria-expanded={expanded3g}
                            aria-label="show more"
                        >
                            <AssessmentOutlinedIcon />
                        </ExpandMore>
                    </Typography>
                </Box>
                <Collapse in={expanded3} timeout="auto" unmountOnExit>
                    <Box mb={5}>
                        <Box mb={2}><strong>a. Median remuneration/ wages</strong></Box>
                        <TableContainer component={Paper}>
                            <Table sx={{ minWidth: 650 }} size="small" >
                                <TableHead sx={{ "& th": { color: '#FFFFFF' } }}>
                                    <TableRow sx={{ backgroundColor: "#4d4d4f" }}>
                                        <TableCell align="center" rowSpan={2}><strong></strong></TableCell>
                                        <TableCell align="center" colSpan={2}><strong>Male</strong></TableCell>
                                        <TableCell align="center" colSpan={2}><strong>Female</strong></TableCell>
                                    </TableRow>
                                    <TableRow sx={{ backgroundColor: "#4d4d4f" }}>
                                        <TableCell align="center"><strong>Number</strong></TableCell>
                                        <TableCell align="center"><strong>Median remuneration/ salary/ wages of respective category</strong></TableCell>
                                        <TableCell align="center"><strong>Number</strong></TableCell>
                                        <TableCell align="center"><strong>Median remuneration/ salary/ wages of respective category</strong></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody sx={{ "& tr": { borderBottom: "1px solid #C3C4BD" } }}>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row">
                                            Board of Directors (BoD)
                                        </TableCell>
                                        <TableCell align='center'>8<sup>*</sup></TableCell>
                                        <TableCell align='center'>1.04 Cr</TableCell>
                                        <TableCell align='center'>4</TableCell>
                                        <TableCell align='center'>1.04 Cr</TableCell>
                                    </TableRow>

                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row">
                                            Key Managerial Personnel
                                        </TableCell>
                                        <TableCell align='center'>4<sup>**</sup></TableCell>
                                        <TableCell align='center'>17.99 Cr</TableCell>
                                        <TableCell align='center'>0</TableCell>
                                        <TableCell align='center'>–</TableCell>
                                    </TableRow>

                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row">
                                            Employees other than BoD and KMP<sup>***</sup>
                                        </TableCell>
                                        <TableCell align='center'>14,476</TableCell>
                                        <TableCell align='center'>0.19 Cr</TableCell>
                                        <TableCell align='center'>2,166</TableCell>
                                        <TableCell align='center'>0.13 Cr</TableCell>
                                    </TableRow>

                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row">
                                            Workers
                                        </TableCell>
                                        <TableCell align='center'>10,060</TableCell>
                                        <TableCell align='center'>0.08 Cr</TableCell>
                                        <TableCell align='center'>63</TableCell>
                                        <TableCell align='center'>0.04 Cr</TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>

                        <Box mb={5} mt={2}>
                            <Typography variant='body2'>
                                * The number includes a former member of the Board of Directors, to whom sitting fees were paid during the reporting period.<br />
                                ** Includes Group CEO &amp; Managing Director and Executive Director &amp; CEO (Auto and Farm Sector) who are also covered in the number of directors on the Board.<br />
                                *** The overall difference in median remuneration/salary/wages observed across gender categories for Employees other than BoD &amp; KMP is largely driven by the workforce composition across management levels, rather than a disparity in pay for equivalent roles. A level-wise analysis reflects an equitable pay structure within each management band.
                            </Typography>
                        </Box>

                        <TableContainer component={Paper}>
                            <Table sx={{ minWidth: 650 }} size="small" >
                                <TableHead sx={{ "& th": { color: '#FFFFFF' } }}>
                                    <TableRow sx={{ backgroundColor: "#4d4d4f" }}>
                                        <TableCell><strong>Category</strong></TableCell>
                                        <TableCell><strong>Sub-category</strong></TableCell>
                                        <TableCell align="center"><strong>Male<br />Median remuneration/ salary/ wages</strong></TableCell>
                                        <TableCell align="center"><strong>Female<br />Median remuneration/ salary/ wages</strong></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody sx={{ "& tr": { borderBottom: "1px solid #C3C4BD" } }}>
                                    <TableRow>
                                        <TableCell component="th" scope="row" rowSpan={3}>
                                            Employees other than BoD and KMP
                                        </TableCell>
                                        <TableCell>Senior Management</TableCell>
                                        <TableCell align="center">0.95 Cr</TableCell>
                                        <TableCell align="center">1.13 Cr</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>Middle Management</TableCell>
                                        <TableCell align="center">0.24 Cr</TableCell>
                                        <TableCell align="center">0.21 Cr</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>Junior Management</TableCell>
                                        <TableCell align="center">0.11 Cr</TableCell>
                                        <TableCell align="center">0.09 Cr</TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>

                        <Box mb={2} mt={4}>
                            <strong>b. Gross wages paid to females as % of total wages paid by the entity:</strong>
                        </Box>

                        <TableContainer component={Paper}>
                            <Table sx={{ minWidth: 650 }} size="small" >
                                <TableHead sx={{ "& th": { color: '#FFFFFF' } }}>
                                    <TableRow sx={{ backgroundColor: "#4d4d4f" }}>
                                        <TableCell align="center"><strong></strong></TableCell>
                                        <TableCell align="center"><strong>FY 2025-26</strong></TableCell>
                                        <TableCell align="center"><strong>FY 2024-25</strong></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody sx={{ "& tr": { borderBottom: "1px solid #C3C4BD" } }}>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row">
                                            Gross wages paid to females as % total wages*
                                        </TableCell>
                                        <TableCell align='center'>8.46%</TableCell>
                                        <TableCell align='center'>8.05%</TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>

                        <Box mt={2}>
                            <Typography variant='body2'>
                                * For the purpose of this disclosure, only wages paid to permanent employees and workers have been considered.
                            </Typography>
                        </Box>
                    </Box>
                </Collapse>
            </Box>
            <Box mt={2} sx={{ borderBottom: 1, borderColor: "#d3d3c8" }}>
                <Box mb={2}>
                    <Box>
                        <Typography variant='body1' sx={{ fontWeight: 'bold', color: "#e31837" }}>
                            4. Do you have a focal point (Individual/ Committee) responsible for addressing human rights impacts or issues caused or contributed to by the business? (Yes/ No)
                            <ExpandMore
                                expand={expanded4}
                                onClick={handleExpandClick4}
                                aria-expanded={expanded4}
                                aria-label="show more"
                            >
                                <ExpandMoreIcon />
                            </ExpandMore>
                        </Typography>
                    </Box>
                </Box>
                <Collapse in={expanded4} timeout="auto" unmountOnExit>
                    <Box mb={5}>
                        <Typography variant='body1'>
                            Yes, there is an Ethics helpline (<a href='https://ethics.mahindra.com' target="_blank" rel="noopener noreferrer">ethics.mahindra.com</a>) that addresses all such issues by the respective Ethics and Governance
                            Committees, which have a structured mechanism for investigation and closure.
                        </Typography>
                    </Box>
                </Collapse>
            </Box>
            <Box mt={2} sx={{ borderBottom: 1, borderColor: "#d3d3c8" }}>
                <Box mb={2}>
                    <Box>
                        <Typography variant='body1' sx={{ fontWeight: 'bold', color: "#e31837" }}>
                            5. Describe the internal mechanisms in place to redress grievances related to human rights issues
                            <ExpandMore
                                expand={expanded5}
                                onClick={handleExpandClick5}
                                aria-expanded={expanded5}
                                aria-label="show more"
                            >
                                <ExpandMoreIcon />
                            </ExpandMore>
                        </Typography>
                    </Box>
                </Box>
                <Collapse in={expanded5} timeout="auto" unmountOnExit>
                    <Box mb={5}>
                        <Typography variant='body1'>
                            The Company has policies and has laid down processes against Sexual harassment and discrimination at workplace.
                            <br></br><br></br>
                            Prevention of Sexual Harassment (PoSH) policy includes processes for addressing complaints relating to sexual harassment at workplace:
                            <ul>
                                <li>Prevention of Sexual Harassment (PoSH) policy is available in eight regional languages.</li>
                                <li>The Company has established Internal Committees at respective regions to handle POSH cases.</li>
                                <li>Complaints can be made to the Internal Committee members through email or letter. In addition to this we also have a centralised email ID (posh@mahindra.com) to receive complaints.</li>
                                <li>The PoSH policy is gender neutral and ensures confidentiality of the complainant.</li>
                                <li>All the complaints pertaining to the financial year are investigated within the timeframe of 90 days as statutorily required.</li>
                            </ul>
                            <br></br>
                            Ethics and Governance policies include processes for human rights grievance redressal practices:
                            <ul>
                                <li>The Company has implemented a detailed Code of Conduct and Whistle-blower policy as a guidance and redressal mechanism to address any violations.</li>
                                <li>Any actual or potential breach of Mahindra’s Code must be reported irrespective of the parties involved, through:
                                    <ul>
                                        <li>SpeakUp Helpline or webportal</li>
                                        <li>Chief Ethics Officer/Human Resource representative/Line Manager</li>
                                        <li>Board of Directors</li>
                                        <li>Directly address to the Chairperson of the Audit Committee</li>
                                        <li>Write to ethics@mahindra.com</li>
                                    </ul>
                                </li>
                                <li>The Whistle-blower policy strictly practices non-retaliation against the complainants and keeps their identity confidential.</li>
                                <li>The Company has established Ethics Committees consisting of senior officials who look into the complaints received, investigations required and actions to be taken.</li>
                            </ul>
                        </Typography>
                    </Box>
                </Collapse>
            </Box>
            <Box mt={2} sx={{ borderBottom: 1, borderColor: "#d3d3c8" }}>
                <Box mb={2}>
                    <Box>
                        <Typography variant='body1' sx={{ fontWeight: 'bold', color: "#e31837" }}>
                            6. Number of Complaints on the following made by employees and workers:
                            <ExpandMore
                                expand={expanded6}
                                onClick={handleExpandClick6}
                                aria-expanded={expanded6}
                                aria-label="show more"
                            >
                                <ExpandMoreIcon />
                            </ExpandMore>
                        </Typography>
                    </Box>
                </Box>
                <Collapse in={expanded6} timeout="auto" unmountOnExit>
                    <Box mb={5}>
                        <TableContainer component={Paper}>
                            <Table sx={{ minWidth: 650 }} size="small" >
                                <TableHead sx={{ "& th": { color: '#FFFFFF' } }}>
                                    <TableRow sx={{ backgroundColor: "#4d4d4f" }}>
                                        <TableCell align="center" rowSpan={2}><strong></strong></TableCell>
                                        <TableCell align="center" colSpan={3}><strong>FY 2025-26</strong></TableCell>
                                        <TableCell align="center" colSpan={3}><strong>FY 2024-25</strong></TableCell>
                                    </TableRow>
                                    <TableRow sx={{ backgroundColor: "#4d4d4f" }}>
                                        <TableCell align="center"><strong>Filed during the year</strong></TableCell>
                                        <TableCell align="center"><strong>Pending resolution at the end of year</strong></TableCell>
                                        <TableCell align="center"><strong>Remarks</strong></TableCell>
                                        <TableCell align="center"><strong>Filed during the year</strong></TableCell>
                                        <TableCell align="center"><strong>Pending resolution at the end of year</strong></TableCell>
                                        <TableCell align="center"><strong>Remarks</strong></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody sx={{ "& tr": { borderBottom: "1px solid #C3C4BD" } }}>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row">
                                            Sexual Harassment
                                        </TableCell>
                                        <TableCell align='center'>29</TableCell>
                                        <TableCell align='center'>2</TableCell>
                                        <TableCell align='center'>NA</TableCell>
                                        <TableCell align='center'>22</TableCell>
                                        <TableCell align='center'>3</TableCell>
                                        <TableCell align='center'>NA</TableCell>
                                    </TableRow>

                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row">
                                            Discrimination at workplace
                                        </TableCell>
                                        <TableCell align='center'>-</TableCell>
                                        <TableCell align='center'>-</TableCell>
                                        <TableCell align='center'>NA</TableCell>
                                        <TableCell align='center'>-</TableCell>
                                        <TableCell align='center'>-</TableCell>
                                        <TableCell align='center'>NA</TableCell>
                                    </TableRow>

                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row">
                                            Child Labour
                                        </TableCell>
                                        <TableCell align='center'>-</TableCell>
                                        <TableCell align='center'>-</TableCell>
                                        <TableCell align='center'>NA</TableCell>
                                        <TableCell align='center'>-</TableCell>
                                        <TableCell align='center'>-</TableCell>
                                        <TableCell align='center'>NA</TableCell>
                                    </TableRow>

                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row">
                                            Forced Labour/ Involuntary Labour
                                        </TableCell>
                                        <TableCell align='center'>-</TableCell>
                                        <TableCell align='center'>-</TableCell>
                                        <TableCell align='center'>NA</TableCell>
                                        <TableCell align='center'>-</TableCell>
                                        <TableCell align='center'>-</TableCell>
                                        <TableCell align='center'>NA</TableCell>
                                    </TableRow>

                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row">
                                            Wages
                                        </TableCell>
                                        <TableCell align='center'>-</TableCell>
                                        <TableCell align='center'>-</TableCell>
                                        <TableCell align='center'>NA</TableCell>
                                        <TableCell align='center'>-</TableCell>
                                        <TableCell align='center'>-</TableCell>
                                        <TableCell align='center'>NA</TableCell>
                                    </TableRow>

                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row">
                                            Other human rights related issues
                                        </TableCell>
                                        <TableCell align='center'>-</TableCell>
                                        <TableCell align='center'>-</TableCell>
                                        <TableCell align='center'>NA</TableCell>
                                        <TableCell align='center'>-</TableCell>
                                        <TableCell align='center'>-</TableCell>
                                        <TableCell align='center'>NA</TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>
                </Collapse>
            </Box>
            <Box mt={2} sx={{ borderBottom: 1, borderColor: "#d3d3c8" }}>
                <Box mb={2}>
                    <Box>
                        <Typography variant='body1' sx={{ fontWeight: 'bold', color: "#e31837" }}>
                            7. Complaints filed under the Sexual Harassment of Women at Workplace (Prevention, Prohibition and Redressal) Act, 2013:
                            <ExpandMore
                                expand={expanded7}
                                onClick={handleExpandClick7}
                                aria-expanded={expanded7}
                                aria-label="show more"
                            >
                                <ExpandMoreIcon />
                            </ExpandMore>
                        </Typography>
                    </Box>
                </Box>
                <Collapse in={expanded7} timeout="auto" unmountOnExit>
                    <Box mb={5}>
                        <TableContainer component={Paper}>
                            <Table sx={{ minWidth: 650 }} size="small" >
                                <TableHead sx={{ "& th": { color: '#FFFFFF' } }}>
                                    <TableRow sx={{ backgroundColor: "#4d4d4f" }}>
                                        <TableCell align="center" width={600}><strong></strong></TableCell>
                                        <TableCell align="center"><strong>FY 2025-26</strong></TableCell>
                                        <TableCell align="center"><strong>FY 2024-25</strong></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody sx={{ "& tr": { borderBottom: "1px solid #C3C4BD" } }}>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row" >
                                            Total Complaints reported under Sexual Harassment of Women at Workplace (Prevention, Prohibition and Redressal) Act, 2013 (POSH)
                                        </TableCell>
                                        <TableCell align='center'>29</TableCell>
                                        <TableCell align='center'>22</TableCell>
                                    </TableRow>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row" >
                                            Complaints on POSH as a % of female employees/ workers
                                        </TableCell>
                                        <TableCell align='center'>0.27%</TableCell>
                                        <TableCell align='center'>0.26%</TableCell>
                                    </TableRow>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row" >
                                            Complaints on POSH upheld
                                        </TableCell>
                                        <TableCell align='center'>16</TableCell>
                                        <TableCell align='center'>12</TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>
                </Collapse>
            </Box>
            <Box mt={2} sx={{ borderBottom: 1, borderColor: "#d3d3c8" }}>
                <Box mb={2}>
                    <Box>
                        <Typography variant='body1' sx={{ fontWeight: 'bold', color: "#e31837" }}>
                            8. Mechanisms to prevent adverse consequences to the complainant in discrimination and harassment cases.
                            <ExpandMore
                                expand={expanded8}
                                onClick={handleExpandClick8}
                                aria-expanded={expanded8}
                                aria-label="show more"
                            >
                                <ExpandMoreIcon />
                            </ExpandMore>
                        </Typography>
                    </Box>
                </Box>
                <Collapse in={expanded8} timeout="auto" unmountOnExit>
                    <Box mb={5}>
                        <Typography variant='body1'>
                            The Company has robust policies and processes against discrimination and harassment-free workplace.
                            <br></br><br></br>
                            The Company has a gender-neutral Prevention of Sexual Harassment (POSH) policy and Whistle-blower policy with stringent processes for maintaining complainant confidentiality and to prevent any kind of retaliation. The Company respects the privacy of the complainant and practices a zero-tolerance approach against any deviation from this practice.
                            <br></br><br></br>
                            Both these policies cover the requirements of applicable laws, and all bona fide complaints are assured utmost confidentiality.
                            <br></br><br></br>
                            The Company’s policies allow reporting violations both anonymously and non-anonymously which have a detailed process of investigation respectively. Further, malicious complaints and complaints made with wrongful intent may also face a disciplinary action post the required investigation.
                        </Typography>
                    </Box>
                </Collapse>
            </Box>
            <Box mt={2} sx={{ borderBottom: 1, borderColor: "#d3d3c8" }}>
                <Box mb={2}>
                    <Box>
                        <Typography variant='body1' sx={{ fontWeight: 'bold', color: "#e31837" }}>
                            9. Do human rights requirements form part of your business agreements and contracts? (Yes/ No)
                            <ExpandMore
                                expand={expanded8}
                                onClick={handleExpandClick8s}
                                aria-expanded={expanded8s}
                                aria-label="show more"
                            >
                                <ExpandMoreIcon />
                            </ExpandMore>
                        </Typography>
                    </Box>
                </Box>
                <Collapse in={expanded8} timeout="auto" unmountOnExit>
                    <Box mb={5}>
                        <Typography variant='body1'>
                            Yes, the Company has a policy on zero child labour, zero tolerance for discrimination at workplace and other human rights
                            violations which extends to the value chain as well.
                        </Typography>
                    </Box>
                </Collapse>
            </Box>
            <Box mt={2} sx={{ borderBottom: 1, borderColor: "#d3d3c8" }}>
                <Box mb={2}>
                    <Box>
                        <Typography variant='body1' sx={{ fontWeight: 'bold', color: "#e31837" }}>
                            10. Assessments for the year:
                            <ExpandMore
                                expand={expanded9}
                                onClick={handleExpandClick9}
                                aria-expanded={expanded9}
                                aria-label="show more"
                            >
                                <ExpandMoreIcon />
                            </ExpandMore>
                        </Typography>
                    </Box>
                </Box>
                <Collapse in={expanded9} timeout="auto" unmountOnExit>
                    <TableContainer component={Paper}>
                        <Table sx={{ minWidth: 650 }} size="small" >
                            <TableHead sx={{ "& th": { color: '#FFFFFF' } }}>
                                <TableRow sx={{ backgroundColor: "#4d4d4f" }}>
                                    <TableCell align="center"><strong>Category</strong></TableCell>
                                    <TableCell align="center"><strong>% of your plants and offices that were assessed (by entity or statutory authorities or third parties)
                                    </strong></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody sx={{ "& tr": { borderBottom: "1px solid #C3C4BD" } }}>
                                <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                    <TableCell component="th" scope="row" >
                                        Child labor
                                    </TableCell>
                                    <TableCell align='center'>100.00 </TableCell>
                                </TableRow>
                                <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                    <TableCell component="th" scope="row" >
                                        Forced/ involuntary labor
                                    </TableCell>
                                    <TableCell align='center'>100.00 </TableCell>

                                </TableRow>
                                <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                    <TableCell component="th" scope="row" >
                                        Sexual Harassment
                                    </TableCell>
                                    <TableCell align='center'>100.00 </TableCell>

                                </TableRow>
                                <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                    <TableCell component="th" scope="row" >
                                        Discrimination at workplace
                                    </TableCell>
                                    <TableCell align='center'>100.00 </TableCell>

                                </TableRow>
                                <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                    <TableCell component="th" scope="row" >
                                        Wages
                                    </TableCell>
                                    <TableCell align='center'>100.00 </TableCell>

                                </TableRow>
                                <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                    <TableCell component="th" scope="row" >
                                        Others - please specify
                                    </TableCell>
                                    <TableCell align='center'>NA </TableCell>

                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <Box mb={5} mt={4}>

                    </Box>
                </Collapse>
            </Box>
            <Box mt={2} sx={{ borderBottom: 1, borderColor: "#d3d3c8" }}>
                <Box mb={2}>
                    <Box>
                        <Typography variant='body1' sx={{ fontWeight: 'bold', color: "#e31837" }}>
                            11. Provide details of any corrective actions taken or underway to address significant risks/ concerns arising from the assessments at Question 9 above
                            <ExpandMore
                                expand={expanded10}
                                onClick={handleExpandClick10}
                                aria-expanded={expanded10}
                                aria-label="show more"
                            >
                                <ExpandMoreIcon />
                            </ExpandMore>
                        </Typography>
                    </Box>
                </Box>
                <Collapse in={expanded10} timeout="auto" unmountOnExit>
                    <Box mb={5}>
                        <Typography variant='body1'>
                            NA
                        </Typography>
                    </Box>
                </Collapse>
            </Box>
            <Box mt={6}>
                <Typography className='heading' variant='h4' sx={{ fontSize: '28px', color: "#e31837" }}>
                    Leadership Indicators
                </Typography>
            </Box>
            <Box mt={2} sx={{ borderBottom: 1, borderColor: "#d3d3c8" }}>
                <Box mb={2}>
                    <Box>
                        <Typography variant='body1' sx={{ fontWeight: 'bold', color: "#e31837" }}>
                            1. Details of a business process being modified/ introduced as a result of addressing human rights grievances/ complaints.
                            <ExpandMore
                                expand={expanded11}
                                onClick={handleExpandClick11}
                                aria-expanded={expanded11}
                                aria-label="show more"
                            >
                                <ExpandMoreIcon />
                            </ExpandMore>
                        </Typography>
                    </Box>
                </Box>
                <Collapse in={expanded11} timeout="auto" unmountOnExit>
                    <Box mb={5}>
                        <Typography variant='body1'>
                            There have been no human rights grievances / complaints in FY 2025-26 requiring the Company to modify its business
                            processes or introduce new business processes.
                        </Typography>
                    </Box>
                </Collapse>
            </Box>
            <Box mt={2} sx={{ borderBottom: 1, borderColor: "#d3d3c8" }}>
                <Box mb={2}>
                    <Box>
                        <Typography variant='body1' sx={{ fontWeight: 'bold', color: "#e31837" }}>
                            2. Details of the scope and coverage of any Human rights due diligence conducted.
                            <ExpandMore
                                expand={expanded12}
                                onClick={handleExpandClick12}
                                aria-expanded={expanded12}
                                aria-label="show more"
                            >
                                <ExpandMoreIcon />
                            </ExpandMore>
                        </Typography>
                    </Box>
                </Box>
                <Collapse in={expanded12} timeout="auto" unmountOnExit>
                    <Box mb={5}>
                        <Typography variant='body1'>
                            The scope and coverage of Human Rights Due Diligence extends to the Company’s operations and its value chain partners.
                            <br /><br />
                            The Company is a signatory to the United Nation Global Compact and is committed to the highest standards of human conduct and the dignity of all those associated with the Company. The Company’s Human Rights Policy ensures that all sectors/business units assess the human rights implications of investments, encompassing new projects, joint ventures, acquisitions of existing businesses, and all business partnerships like vendors, dealers, and suppliers.
                            <br /><br />
                            As part of strengthening its human rights due diligence framework, the Company is currently undergoing the SA8000 certification process an internationally recognized standard for decent workplaces, grounded in the principles of international human rights norms and national labor laws. This process includes a rigorous evaluation of core areas such as child labor, forced or compulsory labor, health and safety, freedom of association, discrimination, disciplinary practices, working hours, and remuneration.
                            <br /><br />
                            The certification process involves comprehensive internal audits, worker interviews, management reviews, and stakeholder engagement, thereby reinforcing the company’s ongoing commitment to ethical labor practices. Once completed, the certification will serve as a formal validation of M&amp;M's human rights management systems and labor standards, both within its operations and across its value chain.
                        </Typography>
                    </Box>
                </Collapse>
            </Box>
            <Box mt={2} sx={{ borderBottom: 1, borderColor: "#d3d3c8" }}>
                <Box mb={2}>
                    <Box>
                        <Typography variant='body1' sx={{ fontWeight: 'bold', color: "#e31837" }}>
                            3. Is the premise/ office of the entity accessible to differently abled visitors, as per the requirements of the Rights of Persons with Disabilities Act, 2016?
                            <ExpandMore
                                expand={expanded13}
                                onClick={handleExpandClick13}
                                aria-expanded={expanded13}
                                aria-label="show more"
                            >
                                <ExpandMoreIcon />
                            </ExpandMore>
                        </Typography>
                    </Box>
                </Box>
                <Collapse in={expanded13} timeout="auto" unmountOnExit>
                    <Box mb={5}>
                        <Typography variant='body1'>
                            Yes. The facilities include ramps, accessible entrances, and designated restrooms to ensure easy access for individuals with disabilities. The entity is committed to providing a barrier-free environment, ensuring that all visitors, regardless of their abilities, can navigate the premises with ease.
                        </Typography>
                    </Box>
                </Collapse>
            </Box>
            <Box mt={2} sx={{ borderBottom: 1, borderColor: "#d3d3c8" }}>
                <Box mb={2}>
                    <Box>
                        <Typography variant='body1' sx={{ fontWeight: 'bold', color: "#e31837" }}>
                            4. Details on assessment of value chain partners:
                            <ExpandMore
                                expand={expanded14}
                                onClick={handleExpandClick14}
                                aria-expanded={expanded14}
                                aria-label="show more"
                            >
                                <ExpandMoreIcon />
                            </ExpandMore>
                        </Typography>
                    </Box>
                </Box>
                <Collapse in={expanded14} timeout="auto" unmountOnExit>
                    <Box mb={2}>
                        <Typography variant='body1'>
                            The Company enforces an ESG-aligned Supplier Code of Conduct and works with suppliers who share the Company’s values and culture of fair, ethical, and responsible business practices. Over a period, 95% of suppliers by its purchase value signed the Supplier Code of Conduct, affirming their compliance with key human rights and labour standards, including provisions related to child labour, forced labour, sexual harassment, wages, working conditions, and non-discrimination.
                            <br /><br />
                            The Company initiated ESG due diligence in FY 2023-24 which was continued through FY26. Cumulatively, due diligence has been completed for 68.1% of suppliers, by value, since FY 2023-24. During FY 2025-26, ESG due diligence was conducted for 11.9% of suppliers, by value.
                            <br /><br />
                            The ESG due diligence is aimed at strengthening responsible sourcing and supply-chain governance. It involves an assessment of employee health &amp; safety, employee wellbeing, environmental impact, working conditions along with other environmental, social and governance aspects. The due-diligence process also evaluates critical social parameters, including child labour, human rights compliance, and minimum wage adherence.
                        </Typography>
                    </Box>

                    <TableContainer component={Paper}>
                        <Table sx={{ minWidth: 650 }} size="small" >
                            <TableHead sx={{ "& th": { color: '#FFFFFF' } }}>
                                <TableRow sx={{ backgroundColor: "#4d4d4f" }}>
                                    <TableCell><strong>Category</strong></TableCell>
                                    <TableCell align="center"><strong>% of value chain partners (by value of business done with such partners) that were assessed
                                    </strong></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody sx={{ "& tr": { borderBottom: "1px solid #C3C4BD" } }}>
                                <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                    <TableCell component="th" scope="row" >
                                        Child labour
                                    </TableCell>
                                    <TableCell align='center' rowSpan={6}>
                                        • 11.9% in FY 2025-26<br />
                                        • 68.1% Cumulatively from FY 2023-24
                                    </TableCell>
                                </TableRow>
                                <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                    <TableCell component="th" scope="row" >
                                        Forced/involuntary labour
                                    </TableCell>
                                </TableRow>
                                <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                    <TableCell component="th" scope="row" >
                                        Sexual harassment
                                    </TableCell>
                                </TableRow>
                                <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                    <TableCell component="th" scope="row" >
                                        Discrimination at workplace
                                    </TableCell>
                                </TableRow>
                                <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                    <TableCell component="th" scope="row" >
                                        Wages
                                    </TableCell>
                                </TableRow>
                                <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                    <TableCell component="th" scope="row" >
                                        Other human rights related issues
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>

                    <Box mb={5} mt={4}>
                    </Box>
                </Collapse>
            </Box>
            <Box mt={2} mb={5} sx={{ borderBottom: 1, borderColor: "#d3d3c8" }}>
                <Box mb={2}>
                    <Box>
                        <Typography variant='body1' sx={{ fontWeight: 'bold', color: "#e31837" }}>
                            5. Provide details of any corrective actions taken or underway to address significant risks/ concerns arising from the assessments at Question 4 above
                            <ExpandMore
                                expand={expanded15}
                                onClick={handleExpandClick15}
                                aria-expanded={expanded15}
                                aria-label="show more"
                            >
                                <ExpandMoreIcon />
                            </ExpandMore>
                        </Typography>
                    </Box>
                </Box>
                <Collapse in={expanded15} timeout="auto" unmountOnExit>
                    <Box mb={5}>
                        <Typography variant='body1'>
                            There are no significant risks/concerns observed during third party ESG due diligence at supplier’s end. As a proactive measure to enforce responsible practices and strengthen supplier awareness, the Company also conducts training programs on human rights as part of its broader ESG training initiatives.
                            <br></br><br></br>
                            The Company always encourages suppliers to report violation of Code of Conduct (CoC) and any questionable behavior through the Company’s protected and confidential reporting channels, details of which are available on the Company’s website or through the designated email address <a href='mailto:speakup2cpo@mahindra.com'>speakup2cpo@mahindra.com</a>. All such communications are kept confidential and due action is taken as per procedures laid down.
                        </Typography>
                    </Box>
                </Collapse>
            </Box>
        </Container>
    )
}


export default Sectionc5;